module.exports = __webpack_public_path__ + "static/media/post-04.6e56af39.png";